var React = require('react');

function DoubleArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31.3 46.4L10.5 23.8L31.3 1.2","stroke":"#FF6600","strokeWidth":"1.9145","key":0}),React.createElement("path",{"d":"M15.8 39.6L1.30005 23.8L15.8 8","stroke":"#FF6600","strokeWidth":"1.9145","key":1})]);
}

DoubleArrow.defaultProps = {"width":"33","height":"48","viewBox":"0 0 33 48","fill":"none"};

module.exports = DoubleArrow;

DoubleArrow.default = DoubleArrow;
